"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.release = exports.version = exports.environment = exports.commerceErrorUrl = exports.addressValidationUrl = exports.commerceDataAggregatorUrl = exports.sessionLogUrl = exports.getMopUrl = exports.updateMopUrl = exports.createMopUrl = exports.paymentUrl = exports.undoCancelUrl = exports.resumeUrl = exports.sibcV2Url = void 0;
var tslib_1 = require("tslib");
var app_config_production_json_1 = tslib_1.__importDefault(require("./app-config.production.json"));
var app_config_development_json_1 = tslib_1.__importDefault(require("./app-config.development.json"));
exports.sibcV2Url = '/checkout/_ajax/chkout/sibcv2';
exports.resumeUrl = '/my/_ajax/my/order/resume';
exports.undoCancelUrl = '/my/_ajax/my/order/undoCancel';
exports.paymentUrl = '/checkout/_ajax/payment/v2';
exports.createMopUrl = "".concat(exports.paymentUrl, "/createmop");
exports.updateMopUrl = "".concat(exports.paymentUrl, "/updatemop");
exports.getMopUrl = "".concat(exports.paymentUrl, "/methods");
exports.sessionLogUrl = '/checkout/_ajax/log';
exports.commerceDataAggregatorUrl = '/checkout/_ajax/commercedataaggregator/v2';
exports.addressValidationUrl = '/checkout/_ajax/addressvalidation';
exports.commerceErrorUrl = '/checkout/_ajax/commerceerrors';
var availableEnvironments = ['production', 'test', 'development'];
var CHEGG_ENV = process.env.CHEGG_ENV === undefined ? 'development' : process.env.CHEGG_ENV;
exports.environment = availableEnvironments.includes(CHEGG_ENV)
    ? CHEGG_ENV
    : 'development';
// sentry release tracking, creating project name and getting version from package json
var project_name = 'checkout-sdk@';
exports.version = '2.32.0';
exports.release = project_name + exports.version;
exports.default = exports.environment === 'production' ? app_config_production_json_1.default : app_config_development_json_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/Config/index.js
// module id = 170
// module chunks = 11